// extracted by mini-css-extract-plugin
export default {"root":"FeaturedStatisticsList-module--root--3df72","statistic":"FeaturedStatisticsList-module--statistic--77dd6","prominent":"FeaturedStatisticsList-module--prominent--d79ec"};